import { render } from "./PersonalDetails.vue?vue&type=template&id=c23743c2&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"

import "./PersonalDetails.vue?vue&type=style&index=0&id=c23743c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23743c2"]])

export default __exports__